import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from '../../../components/ui/avatar';

/**
 * IdentityAvatar - Mostra l'avatar di un'identità con foto dalle settings o fallback alle iniziali
 * @param {string} identityName - Nome dell'identità
 * @param {number} size - Dimensione in pixel (default: 32)
 * @param {Array} identities - Array delle identità dalle settings
 */
export const IdentityAvatar = ({ identityName, size = 32, identities = [] }) => {
  const identityInfo = identities?.find(i => i.name === identityName) || { name: identityName };
  const initials = identityName ? identityName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) : '??';
  
  return (
    <Avatar style={{ width: size, height: size }}>
      {identityInfo?.photo && <AvatarImage src={identityInfo.photo} alt={identityName} />}
      <AvatarFallback className="accent-bg text-white" style={{ fontSize: size * 0.4 }}>
        {initials}
      </AvatarFallback>
    </Avatar>
  );
};

export default IdentityAvatar;
